import dayjs from 'dayjs';
import api from '~/api';
import { PageResponse } from '../../../../_shared/data/dto/PageResponse';
import { Page } from '../../../../_shared/data/models/Page';
import { CustomerResponse, CustomerStatusResponse } from '../dtos/customersResponse';
import { Customer, type CustomerStatus } from '../models/customer.model';

const StatusMap: Record<CustomerStatusResponse, CustomerStatus> = {
  active: 'Live',
  churned: 'Churned',
};

export async function getLiveCustomers(
  partnerId: string,
  { page, search }: { page: number; search: string }
): Promise<Page<Customer>> {
  const { data } = await api.get<PageResponse<CustomerResponse>>(
    `v2/partner/${partnerId}/customers?status=live&page=${page}&search=${search}&ordered_by=created&ordered_type=desc`
  );

  const customers = data.result.map(
    (customer) =>
      new Customer(
        customer.business_name,
        StatusMap[customer.onboarding_status],
        customer.plan.name,
        dayjs(customer.billing_started_date)
      )
  );

  return {
    items: customers,
    search: '',
    totalItems: data.total_count,
    current: page,
  };
}
